import { useState } from "react";
import { useSearchParams } from "react-router-dom";

import TaxIndexesHeader from "./components/TaxIndexesHeader";
import TaxIndexesTable from "./components/TaxIndexesTable";

import complianceService from "../../services/complianceService";
import moment from "moment";

const TaxIndexes = () => {
  const [params] = useSearchParams();

  const year = params.get("year")
    ? params.get("year")
    : moment().format("YYYY");

  const status = params.get("status")
    ? params.get("status") === "1"
      ? { value: 1, label: "Unfiled" }
      : { value: 2, label: "Filed" }
    : "";

  let tax_type = "";

  switch (params.get("type")) {
    case "1":
      tax_type = { value: 5, label: "Income Tax" };
      break;
    case "2":
      tax_type = { value: 4, label: "Percentage Tax - Quarterly" };
      break;
    case "3":
      tax_type = { value: 1, label: "Registration Fee" };
      break;
    default:
      tax_type = "";
  }

  let period = "";

  if (params.get("quarter")) {
    const periods = complianceService.getCORDeadlinePeriods();
    const quarter = Number(params.get("quarter"));

    if (tax_type && tax_type.value === 5) {
      period =
        quarter === 4
          ? { label: "Annual", value: { period_type: 1, period: 1 } }
          : periods.filter(
              (i) => i.value.period_type === 2 && i.value.period === quarter
            )[0];
    }

    if (tax_type && tax_type.value === 4) {
      period = periods.filter(
        (i) => i.value.period_type === 2 && i.value.period === quarter
      )[0];
    }
  }

  const [data, setData] = useState([]);

  const [tableOptions, setTableOptions] = useState({
    tax_type: tax_type,
    year: year,
    status: status,
    period: period,
    search_query: "",
    current_page: 1,
    size: 10,
    sort_column: { path: "deadline", order: "asc" },
  });

  const columns = [
    { path: "support_designation_name", label: "Assignment" },
    { path: "account_name", label: "Name" },
    { path: "tax_type", label: "Tax Type" },
    { path: "period_type_name", label: "Period" },
    { path: "year", label: "Year" },
    { path: "status_type", label: "Status" },
    { path: "deadline", label: "Deadline" },
  ];

  return (
    <div className="px-6 lg:px-0">
      <div className="card">
        <TaxIndexesHeader options={tableOptions} onChange={setTableOptions} />
        <TaxIndexesTable
          data={data}
          columns={columns}
          options={tableOptions}
          onChange={setTableOptions}
          setData={setData}
        />
      </div>
    </div>
  );
};

export default TaxIndexes;
